<template>
  <BenchmarkingWidget
    :area="props.area"
    :zone="props.zone"
    :widget="props.widget"
    :valueType="'integer'"
  >
    <template #icon>
      <IconRepeats style="width: 100%; height: 100%" />
    </template>
    <template #label>
      <div class="widget__label">Engaged Repeat Visits</div>
    </template>
  </BenchmarkingWidget>
</template>

<script setup lang="ts">
import type { WidgetFilter, WidgetTypeVisits, WidgetSetting } from '@/types/Widget';
import IconRepeats from '@/icons/analytics/IconRepeats.svg?component';
import BenchmarkingWidget from './BenchmarkingWidget.vue';

const props = defineProps<{
  widget: WidgetTypeVisits;
  area?: WidgetFilter;
  zone?: WidgetSetting;
}>();
</script>
